import * as React from 'react'
import { styled } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons'
import { O } from '@packages/prelude'
import { ControlButton } from '~/components/Buttons'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  padding: 0 1rem;
`

const UploadButton = styled.button.attrs({
  className: 'btn btn-primary text-white text-uppercase fw-bold px-4 py-2 w-100'
})`
  border-width: 2px;
  border-radius: 2rem;
  font-size: 0.9rem;
  white-space: nowrap;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: var(--bs-white);
  }
`

const RemoveButton = styled(ControlButton)`
  background-color: var(--button-color);
  margin-top: 0 !important;
  border: none !important;

  &:disabled {
    display: none;
  }
`

interface Props {
  onChange: (file: File) => void
  onRemove: () => void
  previewUrl: O.Option<string>
  accept?: string
  readOnly?: boolean
}

export const ImageUpload: React.FC<Props> = ({
  onChange,
  onRemove,
  previewUrl,
  accept = 'image/jpeg,image/png',
  readOnly = false
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null)

  const handleUploadClick = () => {
    inputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      onChange(file)
    }
    // Reset input value to allow selecting the same file again if needed
    if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  const hasImage = O.isSome(previewUrl)

  return (
    !readOnly && (
      <Container>
        <input type="file" ref={inputRef} onChange={handleFileChange} accept={accept} className="d-none" />
        <UploadButton type="button" onClick={handleUploadClick}>
          {hasImage ? 'Bild ändern' : 'Bild hochladen'}
        </UploadButton>
        <RemoveButton type="button" onClick={onRemove} disabled={!hasImage} title="Bild entfernen">
          <FontAwesomeIcon icon={faTimes} />
        </RemoveButton>
      </Container>
    )
  )
}
